import * as React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Paper } from "@mui/material";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Box>{children}</Box>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function ConfigurableTabs(props) {
  const [value, setValue] = React.useState(0);
  const [shouldScroll, setShouldScroll] = React.useState(true);
  const element = React.useRef();
  const parentElement = React.useRef();

  const scroll = {};

  React.useEffect(() => {
    const children =
      parentElement.current.firstChild.firstChild.firstChild.children;

    const newChildren = [...children];

    // console.log(newChildren);

    scroll.scrollHeights = newChildren.map((item, index) => {
      const slicedChildren = newChildren.slice(0, index + 1);

      return slicedChildren.reduce((acc, curr) => {
        return acc + curr.scrollHeight + 20;
      }, 0);
    });

    // console.log(scroll.scrollHeights);
  }, [scroll]);

  React.useEffect(() => {
    if (element.current && !shouldScroll) {
      // console.log("fired", element);
      element.current.scrollIntoView();
    }
  }, [value, shouldScroll]);

  const handleChange = (event, newValue) => {
    // console.log(newValue);
    setShouldScroll(false, setValue(newValue));
    setTimeout(() => setShouldScroll(true), 2500);
  };

  // console.log(shouldScroll);
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        width: "100%",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          scrollDirection: "horizontal",
        }}
      >
        <Tabs
          variant="scrollable"
          sx={{ scrollDirection: "horizontal" }}
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          selectionFollowsFocus={true}
        >
          {props.tabs?.map((item, index) => (
            <Tab label={item.label} {...a11yProps(index)} />
          ))}
        </Tabs>
      </Box>

      <Paper
        ref={parentElement}
        sx={{
          overflow: "auto",
          height: "fit-content",
          margin: "0px 1px",
        }}
        square
        onScroll={(e) => {
          scroll.scrollHeights?.forEach((item, index) => {
            if (
              e.target.scrollTop >=
                (scroll.scrollHeights[index - 1] - 150 || 0) &&
              e.target.scrollTop <= item &&
              shouldScroll === true
            ) {
              setValue(index);
            }
          });
        }}
      >
        <TabPanel value={0} index={0}>
          {props.tabs?.map((item, index) => (
            <Box
              sx={{
                minHeight: "100%",
              }}
              ref={value === index ? element : null}
            >
              {item.content}
            </Box>
          ))}
        </TabPanel>
      </Paper>
    </Box>
  );
}
